import baseAPI from '@/api/base';
import { EditMinyanRoll_N, GetMinyanRoll_N, MoveMinyanRoll_NToFolder, RegisterMinyanRoll_N } from '@/dtos/minyan_roll_N.dto';
import {
  DELETE_MINYAN_ROLL_N_URL,
  EDIT_MINYAN_ROLL_N_URL,
  GET_MINYAN_ROLL_N_URL,
  MOVE_MINYAN_ROLL_N_TO_FOLDER_URL,
  REGISTER_MINYAN_ROLL_N_URL,
  TOGGLE_MINYAN_ROLL_N_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class MinyanRoll_N {
  static getMinyanRolls_N = async (
    getMinyanRoll_N: GetMinyanRoll_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MINYAN_ROLL_N_URL, {
      params: getMinyanRoll_N,
    });
    console.log('response', response);
    return response;
  };

  static registerMinyanRoll_N = async (
    registerMinyanRoll_N: RegisterMinyanRoll_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_MINYAN_ROLL_N_URL,
      {
        ...registerMinyanRoll_N,
      }
    );
    console.log('response', response);
    return response;
  };

  static editMinyanRoll_N = async (
    editMinyanRoll_N: EditMinyanRoll_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_MINYAN_ROLL_N_URL,
      {
        ...editMinyanRoll_N,
      }
    );
    return response;
  };

  static toggleMinyanRoll_NIsActive = async (
    payload: Pick<EditMinyanRoll_N, 'id'> | EditMinyanRoll_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_MINYAN_ROLL_N_IS_ACTIVE_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  static moveMinyanRoll_NToFolder = async (
    moveMinyanRoll_NToFolder: MoveMinyanRoll_NToFolder
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      MOVE_MINYAN_ROLL_N_TO_FOLDER_URL,
      {
        ...moveMinyanRoll_NToFolder,
      }
    );
    return response;
  };

  static deleteMinyanRoll_N = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_MINYAN_ROLL_N_URL}/${id}`
    );
    return response;
  };
}

export default MinyanRoll_N;

